import React from "react";
import PropTypes from "prop-types";
import parse from "html-react-parser";
import style from "./style.module.scss";
/**
 * The label Components for Question Options.
 */
export function Label(props) {
  return (
    <label className={props.className} htmlFor={props.id}>
      <div className={style.label_wrapper}>{parse(props.label)}</div>
    </label>
  );
}

Label.propTypes = {
  /**
   * className to be set for label element
   */
  className: PropTypes.string,
  /**
   * Text to be displayed
   */
  label: PropTypes.string.isRequired,
  /**
   * id for label
   */
  id: PropTypes.number,
};

Label.defaultProps = {
  className: "",
  label: "",
  id: 0,
};
